import { Boundary, Utils } from '@livecontrol/core-ui';
import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Kaboom, NotFound } from './components';
import type { Environment } from './model';
import { Providers } from './providers';
import { Router } from './routes';
import { Reactor, Store } from './store';

export const App = ({ environment }: { environment: Environment }): React.ReactElement | null => {
  const [isReady, setReady] = useState(false);

  // Initialize the global store
  useEffect(
    () => {
      Store.initialize(environment);
      Utils.setIntent();
      setReady(true);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return isReady ? (
    <Providers>
      <BrowserRouter>
        <Reactor>
          <Boundary notFound={NotFound} kaboom={Kaboom}>
            <Router />
          </Boundary>
        </Reactor>
      </BrowserRouter>
    </Providers>
  ) : null;
};
